import Reveal from "@/components/Reveal";

export default function Statement() {
  return (
    <section id="about" className="bg-ink py-24 sm:py-32">
      <div className="mx-auto max-w-[1600px] px-5 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-8">
          <Reveal className="lg:col-span-7">
            <p className="mb-6 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] text-bone/60 sm:text-sm">
              <span className="h-px w-10 bg-steel" />
              The Shop
            </p>
            <h2 className="font-display text-5xl font-black uppercase leading-[0.95] tracking-[0.02em] text-bone sm:text-7xl lg:text-8xl">
              Where Horsepower meets{" "}
              <span className="text-outline">precision.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="flex flex-col justify-end lg:col-span-4 lg:col-start-9">
            <p className="text-lg leading-relaxed text-bone/85 sm:text-xl">
              We deliver breakthrough repair and maintenance that keeps engines
              roaring and tires gripping. Our certified techs dominate complex
              problems fast, so you hit the road with total confidence.
            </p>
            <p className="mt-6 border-l-2 border-steel pl-5 font-display text-2xl font-bold uppercase leading-tight tracking-[0.02em] text-bone sm:text-3xl">
              Precision repairs. Unstoppable performance.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.1} className="mt-16 sm:mt-24">
          <div
            data-testid="about-shop-image"
            className="group relative overflow-hidden border border-bone/10"
          >
            <img
              src="/images/shop-lifts.webp"
              alt="Dreamworlds Garage shop interior with two cars raised on hydraulic lifts"
              className="h-[52vh] w-full object-cover object-[50%_72%] saturate-[1.2] contrast-[1.05] transition-all duration-500 group-hover:scale-[1.03] group-hover:brightness-110 sm:h-[64vh]"
            />
            <div className="pointer-events-none absolute inset-0 bg-ink/10" />
            <div className="absolute bottom-0 left-0 flex items-center gap-3 bg-ink/85 px-6 py-4">
              <span className="h-2 w-2 rotate-45 bg-steel" />
              <span className="font-display text-lg font-semibold uppercase tracking-wide text-bone sm:text-xl">
                3430 West Dunnellon Rd — Dunnellon, FL
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
